import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'
import { StyledSpan, StyledValue } from './ParameterValue.style'

const ParameterValue = ({
  label,
  value,
  postscript,
  stronger,
  onClick,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  size,
  className,
  noColon,
  noValueText,
}) => {
  const displayValue = !value && noValueText ? noValueText : value

  return (
    <StyledSpan
      className={className}
      key={label}
      onClick={onClick}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      size={size}
    >
      {label}
      {!noColon && strings.colon_space}
      <StyledValue styleAsError={!value && Boolean(noValueText)}>
        {stronger ? <strong>{displayValue}</strong> : displayValue}
      </StyledValue>
      {postscript && <span className="postscript">{postscript}</span>}
    </StyledSpan>
  )
}
ParameterValue.defaultProps = {
  size: 'medium',
  stronger: true,
}

ParameterValue.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  noValueText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  postscript: PropTypes.node, // was string, number, element, but needed svg
  stronger: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  className: PropTypes.string,
  noColon: PropTypes.bool,
}

export default ParameterValue
